export const URI_LEGAL_ENTITY = 'organization/legal-entity';
